// extracted by mini-css-extract-plugin
module.exports = {"container":"GamesResult_container__22w7t","textContainer":"GamesResult_textContainer__2faRX","title":"GamesResult_title__2W6db"};